"use client";

import { useCallback, useEffect, useState } from "react";
import { Search } from "lucide-react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

export default function Members() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  var [limit, setLimit] = useState(4);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [showAllMembers, setShowAllMembers] = useState(false);
  const [showAllSearchedMembers, setShowAllSearchedMembers] = useState(false);
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [members, setMembers] = useState([]);
  const [isLoadingMembers, setIsLoadingMembers] = useState(true);
  const location = useLocation();
  const { userId } = location?.state || {};
  const [user, setUser] = useState(null);
  const [canFetch, setCanFetch] = useState(false);
  const [searchedMembers, setSearchedMembers] = useState(null);
  const [pack, setPack] = useState();
  // const pack = useSelector((state) => state.gtm.form.membership);

  // Fetch user data
  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(response.data);
        setPack(response.data.membership.membership_packs);



      }
    } catch (error) {

    } finally {
      setCanFetch(true);
    }
  }, [baseUrl]);

  // Fetch members data
  const fetchMembers = useCallback(async () => {
    if (!user || !user.membership || !user.membership.membership_id) {
      console.error("User or membership data is missing.");
      return;
    }

    try {
      const response = await axios.get(`${baseUrl}/members`, {
        params: {
          membershipId: user?.membership?.membership_id,
          userId: user?.id,
        },
      });
      setMembers(response?.data?.members);
    } catch (error) {
      console.error("Error fetching members:", error);
    } finally {
      setIsLoadingMembers(false);
    }
  }, [baseUrl, user]);

  // Search members
  const searchMembers = useCallback(
    async (name) => {
      try {
        setIsSearchLoading(true);
        const response = await axios.post(
          `${baseUrl}/search-members`,
          {
            membershipId: user?.membership?.membership_id,
            userId: user?.id,
            nom: name,
          },
          {
            withCredentials: true,
            withXSRFToken: true,
            credentials: "include",
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        
        setMembers(null);


        setSearchedMembers(response.data.members);
      } catch (error) {

      } finally {
        setIsSearchLoading(false);
      }
    },
    [baseUrl, user]
  );



  // Debounce function to limit API calls
  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  // Debounced search function
  const debouncedSearch = useCallback(debounce(searchMembers, 150), [
    searchMembers,
  ]);

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    debouncedSearch(value); // Trigger debounced search
    if (value.length == 0) {
      setLimit(4);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  useEffect(() => {
    if (canFetch && user) {
      fetchMembers();
    }
  }, [canFetch, user, fetchMembers]);
  const dispalyMembers = showAllMembers ? members : members?.slice(0, limit);
  const dispalySearchedMembers = showAllSearchedMembers
    ? searchedMembers
    : searchedMembers?.slice(0, limit);
  

  return (
    
          <div className="bg-white bg-opacity-[87%]  min-h-full flex flex-col  items-start p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-16">
            <div className="w-full">
              <div className="max-w-3xl mx-auto">
                <h1 className="text-3xl md:text-4xl font-bold text-center mb-6">
                  {language === "fr" ? "Membres" : "Members"}
                </h1>

                {/* <div className="text-center mb-10">
                  <p className="text-lg mb-1">
                    You need to upgrade your subscription to the
                  </p>
                  <p className="text-lg font-bold mb-1">Golfer+ plan</p>
                  <p className="text-lg">to view all members.</p>
                </div> */}
              </div>

              <div className="max-w-6xl mx-auto mt-16">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                  <h2 className="text-xl font-bold">
                    {language === "fr"
                      ? "Liste des membres"
                      : "List of members"}
                  </h2>
                  <div className="relative w-full md:w-auto">
                    <input
                      type="text"
                      placeholder={
                        language === "fr"
                          ? "Rechercher un membre"
                          : "Search a Member"
                      }
                      className="pl-10 pr-4 py-2 bg-gray-100 rounded-full w-full md:w-64 focus:outline-none"
                      value={searchQuery} // Controlled input
                      onChange={handleSearchChange} // Trigger live search
                    />
                    <Search className="absolute left-3 top-2.5 text-gray-400 h-5 w-5" />
                  </div>
                </div>

                {isLoadingMembers ? (
                  <div className="flex justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
                  </div>
                ) : searchQuery && searchedMembers?.length === 0 ? (
                  <div className="flex justify-center items-center h-64">
                    <p className="text-xl font-medium text-gray-600">
                      {language === "fr"
                        ? "Aucun membre trouvé"
                        : "No member found"}
                    </p>
                  </div>
                ) : searchedMembers?.length > 0 ? (
                  <div className="grid grid-cols-1 w-full gap-4">
                    {dispalySearchedMembers?.map((member) => (
                      <div
                        key={member.id}
                        onClick={() =>
                          navigate("/membership/members-details", {
                            state: {
                              userId: member?.id,
                            },
                          })
                        }
                        className="flex cursor-pointer hover:opacity-65 items-center shadow-lg justify-between p-4 bg-gray-50 rounded-lg"
                      >
                        <div className="flex items-center">
                          <div className="w-14 h-14 relative flex-shrink-0">
                            <img
                              src={member.photo || "/placeholder.svg"}
                              alt=""
                              className="w-14 h-14 rounded-full object-cover"
                            />
                          </div>
                          <div className="ml-4 flex-1 min-w-0">
                            <h3 className="font-bold text-lg truncate">
                              {member.prenom} {member.nom}
                            </h3>
                            <p className="text-gray-700 truncate">
                              {member.entreprise}
                            </p>
                          </div>
                        </div>
                        <div className="text-left w-[30%] font-semibold ml-4">
                          <p className="text-gray-800">{member.poste}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="grid grid-cols-1 w-full gap-4">
                    {dispalyMembers.length > 0 ? (
                      dispalyMembers?.map((member) => (
                        <div
                          key={member.id}
                          onClick={() =>
                            navigate("/membership/members-details", {
                              state: {
                                userId: member?.id,
                              },
                            })
                          }
                          className="lg:flex cursor-pointer hover:opacity-65  items-center shadow-lg justify-between p-4 bg-gray-50 rounded-lg"
                        >
                          <div className="flex items-center">
                            <div className="w-14 h-14 relative flex-shrink-0">
                              <img
                                src={member.photo || "/placeholder.svg"}
                                alt=""
                                className="w-14 h-14 rounded-full object-cover"
                              />
                            </div>
                            <div className="ml-4 flex-1 min-w-0">
                              <h3 className="font-bold text-lg truncate">
                                {member.prenom} {member.nom}
                              </h3>
                              <p className="text-gray-700 truncate">
                                {member.entreprise}
                              </p>
                            </div>
                          </div>
                          <div className="text-left font-semibold ml-4 flex justify-center items-start"> 
                            <p className="text-gray-800 text-start lg:mt-1 mt-6 ">{member.poste}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="flex flex-col gap-5 justify-center items-center h-64">
                        <p className="text-xl font-medium text-gray-600">
                          {language === "fr"
                            ? `Vous êtes ${pack.name}, vous devez passer à Golfer+ pour voir les membres.`
                            : `You are a ${pack.name}, you need to switch to Golfer+ to see the members.`}
                        </p>
                          <button
                            onClick={() => navigate("/membership/demande")}
                            className={`font-bold px-6 py-2 shadow-md md:px-8 hover:opacity-75 md:py-3 rounded-full text-sm md:text-base ${
                              pack?.name === "golfer" ||
                              pack?.name === "golfer+"
                                ? "text-black"
                                : "text-white"
                            }`}
                            style={{
                              backgroundColor: `${pack.color}`,
                            }}
                          >
                            {t("sideBar.upgrade")}
                          </button>
                       
                      </div>
                    )}
                  </div>
                )}
                {members?.length > 4 && (
                  <div className="flex cursor-pointer  flex-col gap-1 md:gap-2 justify-center items-center mt-3 md:mt-5">
                    {!showAllMembers ? (
                      <div
                        onClick={() => {
                          if (dispalyMembers.length + 4 >= members.length) {
                            setShowAllMembers(!showAllMembers);
                          }
                          setLimit(limit + 4);
                        }}
                        className="text-[#0D70A1] items-center flex flex-col text-xl font-bold"
                      >
                        {/* <p>{t("twichiyat.show")}</p> */}
                        <FaAngleDown size={35} color="black" className="" />
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          setShowAllMembers(!showAllMembers);
                          setLimit((limit = 4));
                        }}
                        className="text-[#0D70A1] items-center flex flex-col text-xl font-bold"
                      >
                        <FaAngleUp size={35} color="black" className="" />
                        {/* <p>{t("twichiyat.hide")}</p> */}
                      </div>
                    )}
                  </div>
                )}
                {searchedMembers?.length > 4 && (
                  <div className="flex cursor-pointer flex-col gap-1 md:gap-2 justify-center items-center mt-3 md:mt-5">
                    {!showAllSearchedMembers &&
                    dispalySearchedMembers.length > 0 ? (
                      <div
                        onClick={() => {
                          if (
                            dispalySearchedMembers.length + 4 >=
                            searchedMembers.length
                          ) {
                            setShowAllSearchedMembers(!showAllSearchedMembers);
                          }
                          setLimit(limit + 4);
                        }}
                        className="text-[#0D70A1] items-center flex  text-xl font-bold"
                      >
                        {/* <p>{t("twichiyat.show")}</p> */}
                        <FaAngleDown size={35} color="black" className="" />
                        {/* <p
                          onClick={() => {
                            setShowAllMembers(!showAllMembers);
                            setLimit((limit = 4));
                          }}
                          className="underline text-end"
                        >
                          Minimize ALL
                        </p> */}
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          setShowAllSearchedMembers(!showAllSearchedMembers);
                          setLimit((limit = 4));
                        }}
                        className="text-[#0D70A1] items-center flex  text-xl font-bold"
                      >
                        <FaAngleUp size={35} color="black" className="" />

                        {/* <p>{t("twichiyat.hide")}</p> */}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
      
  );
}
